import { Spinner } from '@apps/web/components/ui/spinner';

export const APP_SESSION_LOADING_COPY = 'Loading…';

export function AppSessionLoading() {
    return (
        <div
            className="bg-background text-muted-foreground flex min-h-screen flex-col items-center justify-center gap-3"
            data-testid="app-session-loading"
            role="status"
            aria-live="polite"
        >
            <Spinner size="xl" tone="muted" />
            <p className="text-sm">{APP_SESSION_LOADING_COPY}</p>
        </div>
    );
}
